import { EntityRoutes } from 'routes/constants';
import { HiringAuthorityIncludes } from 'services/includes';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { ENTITY_TYPE_ID_MAP, HiringAuthorityEntity, TabKeys } from 'UI/constants/entityTypes';
import { PERSISTENCE_KEYS } from 'UI/constants/persistenceKeys';

export const HIRING_AUTHORITY_DRAWERS = {
  Edit: 'edit',
  LinkCandidate: 'linkCandidate',
  Sendout: 'sendout',
  Task: 'task'
};

export const HIRING_AUTHORITY_TAB_IDS = {
  Overview: TabKeys.Overview,
  Companies: TabKeys.Companies,
  Sendouts: TabKeys.Sendouts,
  JobOrders: TabKeys.JobOrders,
  Placements: TabKeys.Placements,
  FeeAgreements: TabKeys.FeeAgreements,
  ActionPlan: TabKeys.Tasks
};

export const HIRING_AUTHORITY_PROFILE_CONFIG = {
  endpoint: Endpoints.HiringAuthorities,
  entityTypeId: ENTITY_TYPE_ID_MAP.hiringAuthority,
  id: HiringAuthorityEntity.id,
  includes: () => [HiringAuthorityIncludes],
  requestAssignmentLabel: strings.inventoryProfiles.common.startRecruiting,
  route: id => EntityRoutes.HiringAuthorityProfile.replace(':id', id),
  sectionName: HiringAuthorityEntity.singular,
  tabsStorageKey: PERSISTENCE_KEYS.PROFILE_TABS.HIRING_AUTHORITIES,
  tabsSubheader: `${HiringAuthorityEntity.singular} ${strings.inventoryProfiles.title}`,
  title: HiringAuthorityEntity.title,
  trackingUrl: Endpoints.HiringAuthorityRecentlyViewed,
  type: 'hiringAuthority'
};
